import Image from 'next/image'
import Link from 'next/link'
import { getReadableImageUrl } from '@/lib/directus'
import { sanitizeHTML } from '@/lib/utils'

interface SecBaProps {
	heading?: {
		title?: string
	}
	text?: {
		text?: string
	}
	before_image?: {
		alt: string
		image_file: {
			image: {
				id: string
				filename_disk: string
			}
		}
	}
	after_image?: {
		alt: string
		image_file: {
			image: {
				id: string
				filename_disk: string
			}
		}
	}
	button: {
		href: string
		label: string
	}
	options: string[]
	id_section: string
}

export const fields = [
	// headings
	'heading.title',

	// text
	'text.text',

	// image
	'before_image.alt',
	'before_image.image_file.image.id',
	'before_image.image_file.image.filename_download',

	// after image
	'after_image.alt',
	'after_image.image_file.image.id',
	'after_image.image_file.image.filename_download',

	// button
	'button.href',
	'button.label',
	'id_section',
	'options',
] as const

export default function SecBa({ data }: { data: SecBaProps }) {
	if (!data) return null

	const isReversed = data?.options?.includes('flex-row-reverse')
	return (
		<section
			id={data.id_section || 'ba'}
			className='SecBa w-full bg-[#737a7d] py-16'
		>
			<div
				className={`container flex flex-wrap gap-2 xl:gap-12 items-center ${
					isReversed ? 'md:flex-row-reverse' : ''
				}`}
			>
				{/* Before & After Images */}
				<div className='image-element flex flex-wrap gap-6 md:gap-2 xl:gap-6 w-full md:flex-1'>
					{/* Before Image */}
					<div className='w-full md:flex-1 aspect-[4/3] bg-neutral-50 rounded-lg overflow-hidden'>
						<div className='relative w-full h-full'>
							<Image
								src={getReadableImageUrl(
									data?.before_image?.image_file?.image?.id || '',
									data?.before_image?.image_file?.image?.filename_disk || ''
								)}
								alt={data?.before_image?.alt || ''}
								fill
								sizes='(max-width: 768px) 100vw, 50vw'
								className='object-cover object-center'
								priority
							/>
							<div className='absolute bottom-3 right-5 text-white text-base xl:text-xl uppercase'>
								Before
							</div>
						</div>
					</div>

					{/* After Image */}
					<div className='w-full md:flex-1 aspect-[4/3] bg-neutral-50 rounded-lg overflow-hidden'>
						<div className='relative w-full h-full'>
							<Image
								src={getReadableImageUrl(
									data?.after_image?.image_file?.image?.id || '',
									data?.after_image?.image_file?.image?.filename_disk || ''
								)}
								alt={data?.after_image?.alt || ''}
								fill
								sizes='(max-width: 768px) 100vw, 50vw'
								className='object-cover object-center'
								priority
							/>
							<div className='absolute bottom-3 right-5 text-white text-base xl:text-xl uppercase'>
								After
							</div>
						</div>
					</div>
				</div>

				<div className='max-lg:mt-12 text-element flex flex-row items-center gap-6 xl:gap-12 w-full lg:w-1/2 xl:w-1/3'>
					<Image
						src='/images/hfps-brand-vertical.svg'
						alt='HFPS Brand'
						width={25}
						height={198}
						className='max-lg:w-[15px] hidden md:block'
					/>

					<div className='flex flex-col gap-6'>
						<h2 className='text-white'>{data?.heading?.title || ''}</h2>
						<div
							className='text-white grid gap-6'
							dangerouslySetInnerHTML={sanitizeHTML(data?.text?.text || '')}
						/>
						<Link
							href={data?.button?.href || '/'}
							className='btn'
							onClick={e => {
								if (data?.button?.href) {
									e.preventDefault()
									window.location.href = data?.button?.href
								}
							}}
						>{data?.button?.label || 'View Galleries'}
						</Link>
					</div>
				</div>
			</div>
		</section>
	)
}